module.exports = __webpack_public_path__ + "img/lei.809e8785.png";